// extracted by mini-css-extract-plugin
export default {"dynamic-media-picture":"tMVATVD","transparent":"xWq7Biw","loading":"O0aBGzZ","noLogo":"ofdHJ2w","image":"ruN2ZTg","objectFit":"M9pKE3i"};